/** @jsx jsx */
import { css, jsx } from '@emotion/react';
import classnames from 'classnames';
import { setStyle } from '../utility';
const { Component } = wp.element;
import { __ } from '@wordpress/i18n';
const {
	Tooltip,
	BaseControl,
	ColorGradientControl,
	ColorPicker,
	RangeControl,
	Popover,
	Button,
} = wp.components;
const { ColorPalette } = wp.blockEditor;

export default class CustomColorPicker extends Component {
	constructor() {
		super(...arguments);

		this.state = {
			colorKey: false,
		};
	}

	// handleClick = () => {
	// 	this.setState(
	// 		{
	// 			displayColorPicker: !this.state.displayColorPicker,
	// 		},
	// 		() => {
	// 			const { updateLabel, title } = this.props;

	// 			updateLabel(title);
	// 		}
	// 	);
	// };

	// handleClose = () => {
	// 	this.setState(
	// 		{
	// 			displayColorPicker: false,
	// 		},
	// 		() => {
	// 			const { updateLabel } = this.props;

	// 			updateLabel('');
	// 		}
	// 	);
	// };

	resetColor = () => {
		const {
			title,
			updateLabel,
			update,
			attributes,
			setAttributes,
			parentProps,
		} = this.props;

		const currentColor = attributes[update]; // Current color value.
		const currentTheme = attributes.theme; // Current theme name.

		const defaultColor = parentProps.rawCoreThemes[update].default; // Default color value from the 'default' theme.
		const customDefaultColor =
			parentProps.coreThemes[currentTheme].faq_attributes[update]; // Overridden default color value (if defined).

		const newColor =
			customDefaultColor !== undefined
				? customDefaultColor
				: defaultColor;
		setAttributes({ [update]: newColor });
		updateLabel(title, update);
	};

	handleHoverOver = () => {
		const { title, updateLabel, update } = this.props;
		updateLabel(title, update);
	};

	handleColorPickerChange = (color) => {
		const { update } = this.props;
		let newCol = '';

		if ('string' === typeof color) {
			// Use color selected in the color palette.
			newCol = color;
		} else if (1 !== color.rgb.a) {
			// Use rgba value selected in the color picker if alpha is less than 1.
			newCol = `rgba(${color.rgb.r}, ${color.rgb.g}, ${color.rgb.b}, ${color.rgb.a})`;
		} else {
			// Use hex value selected in the color picker.
			newCol = color.hex;
		}
		setStyle(update, newCol, this.props);
	};

	handleColorPaletteChange = (color) => {
		// For some reason it seems that if the same custom palette color is clicked twice in succession the ColorPalette component onChange event passes undefined rather than the same color value.
		if (undefined === color) {
			return;
		}

		const { update } = this.props;
		let newCol = '';

		if ('string' === typeof color) {
			// Use color selected in the color palette.
			newCol = color;
		}

		this.setState({
			colorKey: color,
		});

		setStyle(update, newCol, this.props);
	};

	render() {
		const {
			value,
			//onChange,
			onOpacityChange,
			label,
			alpha = false,
			valueOpacity,
			attribute,
		} = this.props;

		const { colorKey } = this.state;

		const toggleVisible = () => {
			this.setState({ isVisible: true });
		};

		const toggleClose = () => {
			if (this.state.isVisible === true) {
				this.setState({ isVisible: false });
			}
		};

		const swatchCSS = css`
			z-index: 0;
			/* &:hover {
				border: 2px solid rgba(255, 255, 255, 0.25);
			} */

			//width: 25px;
			//height: 25px;
			background-color: ${attribute};
			//border-radius: 100%;
			//border: 2px solid transparent;

			//&:hover {
			//	border: 2px solid rgba(255, 255, 255, 0.5);
			//}
		`;

		const bg =
			'rgba(170, 170, 170, 0)' === attribute
				? `--checkerSize: 5px; /* edit me */
		--checkerColor: #f2f2f2;

		border: 1px #f5f5f5 solid;

		background-image: linear-gradient(
				45deg,
				var(--checkerColor) 25%,
				transparent 25%
			),
			linear-gradient(
				135deg,
				var(--checkerColor) 25%,
				transparent 25%
			),
			linear-gradient(45deg, transparent 75%, var(--checkerColor) 75%),
			linear-gradient(
				135deg,
				transparent 75%,
				var(--checkerColor) 75%
			);

		background-size: calc(2 * var(--checkerSize))
			calc(2 * var(--checkerSize));

		background-position: 0 0, var(--checkerSize) 0,
			var(--checkerSize) calc(-1 * var(--checkerSize)),
			0px var(--checkerSize);`
				: '';

		const swatchWrapperCSS = css`
			width: 25px;
			height: 25px;
			border-radius: 50%;
			background-color: ${attribute};
			margin: 0 5px 5px 0;
			${bg}
		`;

		const colorPickerCSS = css`
			padding: 15px;
		`;

		const colorPickerEnd = wp.hooks.applyFilters(
			'color-picker-end',
			'',
			this.resetColor
		);

		return (
			<div onMouseEnter={this.handleHoverOver}>
				<div>
					{!this.state.isVisible && (
						<button
							style={{
								backgroundColor: 'transparent',
								border: '0',
								padding: '0',
								margin: '0',
							}}
							type="button"
							className=""
							onClick={toggleVisible}
						>
							<div
								className="components-color-picker__swatch"
								css={swatchWrapperCSS}
							>
								<div
									className="components-color-picker__active"
									css={swatchCSS}
								/>
							</div>
						</button>
					)}
					{this.state.isVisible && (
						<button
							style={{
								backgroundColor: 'transparent',
								border: '0',
								padding: '0',
								margin: '0',
							}}
							type="button"
							className=""
							onClick={toggleClose}
						>
							<div
								className="components-color-picker__swatch"
								css={swatchWrapperCSS}
							>
								<div
									className="components-color-picker__active"
									css={swatchCSS}
								/>
							</div>
						</button>
					)}
				</div>

				{this.state.isVisible && (
					<Popover
						position="top left"
						className=""
						onClose={toggleClose}
					>
						<div css={colorPickerCSS}>
							<ColorPicker
								key={colorKey}
								color={attribute}
								onChangeComplete={this.handleColorPickerChange}
								disableAlpha={false}
							/>
							<div style={{ margin: '10px 0' }}></div>
							<ColorPalette
								value={attribute}
								onChange={this.handleColorPaletteChange}
								disableCustomColors={true}
								clearable={false}
							/>
							{colorPickerEnd}
						</div>
					</Popover>
				)}
			</div>
		);
	}
}
